import { hudPaths } from '../content';
import { DeliveryPipelineScreen } from '../sections';
import { PageActionBar } from './PageActionBar';

export const WorkflowDeliveryPage = () => {
  return (
    <>
      <DeliveryPipelineScreen />
      <PageActionBar activePath={hudPaths.workflowPipeline} ctaLabel="Start Delivery Discovery Brief" />
    </>
  );
};
